import React, { useMemo } from 'react';
import cn from 'classnames';
import styles from './PickTemplates.module.css';
import useTemplateRegistry from '../../../../hooks/useTemplateRegistry.hook';
import {CustomSelect} from '../../../Select/Select';
import KeyValueItem from '../KeyValueItem/KeyValueItem';

function makeRow(key = '{{}}', defaultValue = undefined) {
	const today = new Date();
	const formattedDate = `${String(today.getDate()).padStart(2,'0')}.${String(today.getMonth()+1).padStart(2,'0')}.${today.getFullYear()}`;
	const normalizedKey = typeof key === 'string' ? key : '{{}}';
	return {
 		id: `${Date.now()}_${Math.random().toString(36).slice(2, 9)}`,
 		key: normalizedKey,
		value: defaultValue ?? (normalizedKey.toLowerCase().includes('дата') ? formattedDate : '')
	};
}

export function buildPlaceholdersForTemplate(template) {
	return (template?.input_placeholders || []).map((p) => {
		const row = makeRow(p.key, p.default);
		if (row.key.toLowerCase().includes('дата')) {
			const today = new Date();
			row.value = `${String(today.getDate()).padStart(2,'0')}.${String(today.getMonth()+1).padStart(2,'0')}.${today.getFullYear()}`;
		}
		return row;
	});
}

export default function PickTemplates({
	groupName,
	selectedTemplate,
	setSelectedTemplate,
	placeholders,
	setPlaceholders,
	hideSelect = false
}) {
	const { groupTemplates, byCode } = useTemplateRegistry();
	const templates = groupTemplates(groupName);

	const options = useMemo(
		() => templates.map((t) => ({ label: t.title, value: t.code })),
		[templates]
	);

	const handleSectionChange = (optionOrValue) => {
		const value = typeof optionOrValue === 'string' ? optionOrValue : optionOrValue?.value;
		if (!value) {
			setSelectedTemplate('');
			setPlaceholders([]);
			return;
		}

		setSelectedTemplate(value);
		setPlaceholders(buildPlaceholdersForTemplate(byCode[value]));
	};

	const handleAddRow = () => {
		setPlaceholders((prev) => {
			const newRow = makeRow('');
			if (newRow.key.toLowerCase().includes('дата')) {
				const today = new Date();
				newRow.value = `${String(today.getDate()).padStart(2,'0')}-${String(today.getMonth()+1).padStart(2,'0')}-${today.getFullYear()}`;
			}
			return [...prev, newRow];
		});
	};
	
	const handleEditRow = (id, patch) =>
		setPlaceholders((prev) =>
			prev.map((r) => {
				if (r.id !== id) return r;
				return { ...r, ...patch };
			})
		);
	const handleRemoveRow = (id) => setPlaceholders((prev) => prev.filter((r) => r.id !== id));

	return (
		<div className={cn(styles.templatesBox, hideSelect && styles.templatesBoxPlain)}>
			{!hideSelect && (
				<CustomSelect
					options={options}
					value={options.find((o) => o.value === selectedTemplate) || null}
					onChange={handleSectionChange}
					placeholder="Выберите шаблон"
					width="100%"
				/>
			)}
			{selectedTemplate && (
				<div className={styles.kvContainer}>
					{placeholders.map((row) => (
						<KeyValueItem
							key={row.id}
							row={row}
							onEdit={handleEditRow}
							onRemove={handleRemoveRow}
						/>
					))}
					<div className={styles.controlsRow}>
						<button type="button" className={styles.addBtn} onClick={handleAddRow}>
							<img src="/icons/plus-icon.svg" alt="add" className={styles.icon} /> Добавить строку
						</button>
					</div>
				</div>
			)}
		</div>
	);
}
